<template>
  <div class="gs-app gm-campaign-show">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="gm-campaign-show__content flex flex-col sm:w-11/12 lg:w-7/12 m-auto">
      <div class="mt-20 mb-10 text-center">
        <div class="items-center text-deep-dark mb-4" style="font-size: 26px">
          {{ campaign.name ? campaign.name : 'N/A' }}
          {{
            $t('frontend_groovemail_campaign_details_campaign_name_header')
          }}
        </div>
      </div>
      <div class="gm-campaign-show__metrics flex mb-10" v-if="campaign.method === 'email'">
        <div class="flex w-1/3 mr-4">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div class="text-deep-dark p-5 pb-1" style="font-size: 18px">
              {{ $t('frontend_groovemail_campains_total_opens') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{ campaign.open ? campaign.open : 0 }}
            </div>
          </div>
        </div>
        <div class="flex w-1/3 mr-4">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div
              class="items-center text-deep-dark p-5 pb-1"
              style="font-size: 18px"
            >
              {{ $t('frontend_groovemail_broadcasts_show_unique_opens') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{
                campaign.unique_open_count ? campaign.unique_open_count : 0
              }}
            </div>
          </div>
        </div>
        <div class="flex w-1/3 mr-4">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div
              class="items-center text-deep-dark p-5 pb-1"
              style="font-size: 18px"
            >
              {{ $t('frontend_groovemail_campains_total_clicks') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{ campaign.click ? campaign.click : 0 }}
            </div>
          </div>
        </div>
        <div class="flex w-1/3 mr-4">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div
              class="items-center text-deep-dark p-5 pb-1"
              style="font-size: 18px"
            >
              {{ $t('frontend_groovemail_broadcasts_show_unique_clicks') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{
                campaign.unique_click_count ? campaign.unique_click_count : 0
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="gm-campaign-show__metrics flex mb-10" v-else-if="campaign.method === 'postal'">
        <div class="flex w-1/3 mr-4">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div class="text-deep-dark p-5 pb-1" style="font-size: 18px">
              {{ $t('frontend_groovemail_admin_campaign_total_recipients') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{ campaign.total_recipients ? campaign.total_recipients : 0 }}
            </div>
          </div>
        </div>
        <div class="flex w-1/3 mr-4">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div
              class="items-center text-deep-dark p-5 pb-1"
              style="font-size: 18px"
            >
              {{ $t('frontend_groovemail_campaigns_create_postal_integration_postal_delivered_label') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{
                campaign.postal_delivered ? campaign.postal_delivered : 0
              }}
            </div>
          </div>
        </div>
        <div class="flex w-1/3">
          <div
            class="w-full btn-radius bg-white"
            style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
          >
            <div
              class="items-center text-deep-dark p-5 pb-1"
              style="font-size: 18px"
            >
              {{ $t('frontend_groovemail_campaigns_create_postal_integration_postal_undelivered_label') }}
            </div>
            <div class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1">
              {{ campaign.failed_recipients ? campaign.failed_recipients : 0 }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-10">
        <div class="text-2xl text-deep-dark font-bold mb-4">
          {{ $t('frontend_groovemail_campaign_name') }}
        </div>
        <div
          class="btn-radius p-6 bg-white"
          style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
        >
          <div class="text-grey-700 text-base">
            {{ campaign.name ? campaign.name : 'N/A' }}
          </div>
        </div>
      </div>
      <div class="mb-10" v-if="campaign.method !== 'postal'">
        <div class="text-2xl text-deep-dark font-bold mb-4">
          {{ $t('frontend_groovemail_campains_step2_sender') }}
        </div>
        <div
          class="btn-radius p-6 bg-white"
          style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
        >
          <p class="text-gery-800 mb-1" v-if="campaign.sendername">
            {{ $t('frontend_groovemail_broadcast_sent_by') }} <b>{{ campaign.sendername }}</b>
          </p>
          <p class="text-grey-700 text-base">
            {{ $t('frontend_email') }}: {{ campaign.senderemail ? campaign.senderemail : 'N/A' }}
          </p>
        </div>
      </div>

      <div class="mb-10" v-if="campaign.method === 'postal' && campaign.postal_campaign_id">
        <div class="text-2xl text-deep-dark font-bold mb-4">
          {{
            $t('frontend_groovemail_campaigns_create_postal_integration_postal_statistics_label')
          }}
        </div>
        <div
          class="flex items-center btn-radius p-6 bg-white"
          style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
        >
          <div>
            <p
              class="text-primary cursor-pointer font-bold"
              @click="showStatisticsForPostal()"
            >
              {{
                $t('frontend_groovemail_campaigns_create_postal_integration_postal_click_here_stats')
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="mb-10">
        <div class="text-2xl text-deep-dark font-bold mb-4">
          {{
            $t('frontend_groovemail_campaign_details_campaign_name_header')
          }}
          {{ $t('frontend_type') }}
        </div>
        <div
          class="flex items-center btn-radius p-6 bg-white"
          style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
        >
          <div class="mr-4">
            <div v-if="campaign.method === 'email'">
              <CampaignEmailIcon />
            </div>
            <div v-if="campaign.method === 'sms'">
              <CampaignSmsIcon />
            </div>
            <div v-if="campaign.method === 'postal'">
              <CampaignPostalIcon />
            </div>
          </div>
          <div>
            <div class="text-deep-dark text-xl font-bold">
              {{
                campaign.method === 'email'
                  ? $t(
                    'frontend_groovemail_forms_step2_send_by_mail'
                  )
                  : (
                    campaign.method === 'sms'
                    ? $t(
                    'frontend_groovemail_forms_step2_send_by_sms'
                    )
                    : $t(
                    'frontend_groovemail_campaigns_wizard_broadcasts_campaign_send_option_postal'
                    )
                  )
              }}
            </div>
            <div class="text-grey-700 text-sm">
              {{
                campaign.method === 'email'
                  ? $t(
                    'frontend_groovemail_campaigns_wizard_broadcasts_campaign_send_option_email_details_page'
                  )
                  : (
                    campaign.method === 'sms'
                    ? $t(
                    'frontend_groovemail_campaigns_wizard_broadcasts_campaign_send_option_sms_desc_details_page'
                    )
                    : $t(
                    'frontend_groovemail_campaigns_wizard_broadcasts_campaign_send_option_postal_details_page'
                    )
                  )
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-20" v-if="campaign.method !== 'postal'">
        <div class="text-2xl text-deep-dark font-bold mb-4">
          {{ $t('frontend_groovemail_campain_message') }}
        </div>
        <div
          class="btn-radius bg-white"
          style="box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05)"
        >
          <div class="flex p-6 pb-0 items-center">
            <div
              class="text-grey-700 text-base"
              v-if="campaign.method === 'email'"
            >
              <span class="text-deep-dark"
                >{{
                  $t(
                    'frontend_groovemail_campaigns_wizard_broadcasts_campaign_subject_line_header'
                  )
                }}:</span
              >
              {{ campaign.subject ? campaign.subject : 'N/A' }}
            </div>
          </div>
          <div class="my-2 p-4 pt-0 pb-6" v-if="campaign.method === 'sms'">	
            <div class="text-deep-dark px-2 pb-2">	
              {{ $t('frontend_groovemail_campains_step4_message_content') }}:	
            </div>	
            <VuePerfectScrollbar>	
              <campaign-preview	
                :campaignMethod="campaign.method"	
                :campaignMessage="campaign.message"	
              ></campaign-preview>	
            </VuePerfectScrollbar>	
          </div>	
          <div class="my-2 p-4 pt-0 pb-6" v-if="campaign.method === 'email'">	
            <div class="text-deep-dark px-2 pb-2">	
              {{ $t('frontend_groovemail_campains_step4_message_content') }}:	
            </div>	
            <VuePerfectScrollbar>	
              <div class="w-full p-6" style="height: calc(100vh - 115px)">	
                <div	
                  v-shadow
                >	
                  <div	
                    class="pb-6"	
                    v-html="	
                      campaign.message +	
                      `<p style='margin: 0px'><br></p>` +	
                      unsubscribeContent	
                    "	
                  ></div>	
                </div>	
              </div>	
            </VuePerfectScrollbar>	
          </div>	
        </div>	
      </div>	
    </div>

    <portal to="headerBreadCrumb">
      <div
        class="flex h-full items-center cursor-pointer text-grey-500 hover:text-primary"
        @click="moveBackToBroadcastListing"
      >
        <ExitIcon class="w-5 h-5"/>
      </div>
    </portal>
  </div>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Campaign from '@/models/Campaign';
import themeConfig from '@/theme/themeConfig.js';
import CampaignPreview from './campaign-preview.vue';

// import icons
import ExitIcon from '@/assets/images/icons/new/exit_arrow_new.svg';
import CampaignEmailIcon from '@/assets/images/icons/Camp-Email.svg';
import CampaignSmsIcon from '@/assets/images/icons/Camp-Sms.svg';
import CampaignPostalIcon from '@/assets/images/icons/campaign-postal-icon.svg';

export default {
  middleware: 'auth',
  layout: 'defaultWithoutSidebarLogo',
  data() {
    return {
      campaign: [],
      fullPageLoader: true,
      isLoading: false,
      unsubscribeContent: '',
      loaderColor: themeConfig.appPrimaryColor,
    };
  },

  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_campaign_detail_route_page_title'),
    };
  },

  async created() {
    this.showLoader();
    this.campaign = await Campaign.$find(this.$route.params.id);
    if (this.campaign.method === 'email') {	
      const unsubscribeData = await axios.get('/setting/get-unsubscribe-layout');	
      this.unsubscribeContent = unsubscribeData.data.footer_layout;
    }
    this.hideLoader();
  },

  components: {
    VuePerfectScrollbar,
    CampaignPreview,
    CampaignEmailIcon,
    CampaignSmsIcon,
    CampaignPostalIcon,
    ExitIcon,
  },

  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    showStatisticsForPostal() {
      window.open(`https://app.closem.ai/index.php?m=campaigns&d=campaigndetails&id=${this.campaign.postal_campaign_id}`);
    },

    async moveBackToBroadcastListing() {
      if (this.$route.query && this.$route.query.from === 'broadcast-listing') {
        this.$router.push({ name: 'Broadcasts' });
      } else if (
        this.$route.query &&
        this.$route.query.from === 'broadcast-analytics-listing'
      ) {
        this.$router.push({ name: 'BroadcastAnalytics' });
      }
    },
  },
};
</script>

<style scoped>
.gm-campaign-show {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-campaign-show__content {
  max-width: 1120px;
}

.gm-campaign-show__metrics > .flex > .w-full {
  min-width: 0;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-campaign-show {
    padding: 16px;
  }

  .gm-campaign-show__metrics {
    flex-direction: column;
    gap: 14px;
  }

  .gm-campaign-show__metrics > .flex {
    width: 100%;
    margin-right: 0;
  }

  .gm-campaign-show__metrics > .flex > .w-full {
    border-radius: var(--gs-radius-md);
  }
}
</style>
